import React, { memo } from 'react'

import { arrayOf, number, shape, string } from 'prop-types'

// The user's sent turn: reference-image thumbnails and the prompt bubble.
function SentMessage({ prompt = '', images }) {
  return (
    <div className="image-assistant-create-tab__message">
      {images.length > 0 && (
        <div className="image-assistant-create-tab__message-images">
          {images.map(image => (
            <img key={image.id} className="image-assistant-create-tab__message-image" src={image.url} alt="" />
          ))}
        </div>
      )}
      {prompt && <p className="image-assistant-create-tab__bubble cgt-body-base">{prompt}</p>}
    </div>
  )
}

SentMessage.propTypes = {
  prompt: string,
  images: arrayOf(shape({ id: number, url: string })).isRequired,
}

export default memo(SentMessage)
